export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Reply-Gray-d5ec99bfbbd3b0f456aceef7f4328653.svg";